document.addEventListener('DOMContentLoaded', function () {
  const hero = document.querySelector('.js-hero-toggle');

  if (hero) {
    hero.addEventListener('click', function () {
      hero.classList.toggle('is-active');
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const lazyVideos = document.querySelectorAll('video.js-lazy-video');
  if (!lazyVideos.length) return;

  const loadVideo = function (video) {
    if (video.dataset.loaded === 'true') return;
    video.dataset.loaded = 'true';

    const sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (source) {
      source.src = source.dataset.src;
    });

    if (video.dataset.src) {
      video.src = video.dataset.src;
    }

    video.load();
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /* 自動再生がブロックされた場合は poster のまま表示 */
      });
    }
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '300px 0px',
      threshold: 0.01
    });

    lazyVideos.forEach(function (video) {
      observer.observe(video);
    });
  } else {
    lazyVideos.forEach(loadVideo);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.js-feature-slider');
  if (!slider) return;

  const track = slider.querySelector('.features__track');
  const cards = Array.from(slider.querySelectorAll('.feature-card'));
  const prev = slider.querySelector('.features__nav--prev');
  const next = slider.querySelector('.features__nav--next');
  const textBox = document.querySelector('.js-feature-text');

  let current = 1; // 最初は2枚目を中央にする

  function renderSlider() {
    const total = cards.length;
    const leftIndex = (current - 1 + total) % total;
    const centerIndex = current;
    const rightIndex = (current + 1) % total;

    track.innerHTML = '';

    [leftIndex, centerIndex, rightIndex].forEach(function (index) {
      const card = cards[index];
      card.classList.toggle('is-active', index === centerIndex);
      track.appendChild(card);
    });

    const activeCard = cards[centerIndex];

    if (textBox && activeCard) {
      textBox.innerHTML =
        '<p>' + activeCard.dataset.text + '</p>';
    }
  }

  if (next) {
    next.addEventListener('click', function () {
      current = (current + 1) % cards.length;
      renderSlider();
    });
  }

  if (prev) {
    prev.addEventListener('click', function () {
      current = (current - 1 + cards.length) % cards.length;
      renderSlider();
    });
  }

  cards.forEach(function (card, index) {
    card.addEventListener('click', function () {
      current = index;
      renderSlider();
    });
  });

  renderSlider();
});